// extracted by mini-css-extract-plugin
module.exports = {"nav":"NavBar_nav__uDGth","navnoHeader":"NavBar_navnoHeader__wul31","scrollingWrapper":"NavBar_scrollingWrapper__h_WqB","active":"NavBar_active__c2WdO"};